const parseCommaSeparatedValues = strValue => strValue
  .split(',')
  .map(val => val.trim())
  .filter(val => val !== '');

const fixDataTypes = sheetAsJson =>
  sheetAsJson.map(bookToTaxDifference => ({
    ...bookToTaxDifference,
    disallowedPercentage: isNaN(parseFloat(bookToTaxDifference.disallowedPercentage))
      ? (bookToTaxDifference.disallowedPercentage || null)
      : parseFloat(bookToTaxDifference.disallowedPercentage),
    countryTaxTypes: parseCommaSeparatedValues(bookToTaxDifference.countryTaxTypes),
    excludedCompanyCodes: parseCommaSeparatedValues(bookToTaxDifference.excludedCompanyCodes),
    connections: parseCommaSeparatedValues(bookToTaxDifference.connections),
    businessUnits: parseCommaSeparatedValues(bookToTaxDifference.businessUnits),
  }));

export default fixDataTypes;
